import { z } from "zod";

export const anthropicModels = ["claude-opus-5", "claude-sonnet-5", "claude-haiku-4-5"] as const;
export const anthropicModelSchema = z.enum(anthropicModels);
export const anthropicConnectionInput = z.object({
  id: z.uuid().optional(),
  name: z.string().trim().min(1),
  apiKey: z.string().trim().optional(),
});
export const anthropicTestResult = z.object({ model: z.string() });
export const outboundChannels = ["email", "linkedin", "twitter"] as const;
export type OutboundChannel = (typeof outboundChannels)[number];
export const outboundChannelSchema = z.enum(outboundChannels);
export const outboundRequestSchema = z
  .object({
    channel: outboundChannelSchema,
    model: anthropicModelSchema,
    promptKey: z.string().trim().min(1).nullable().optional(),
  })
  .strict();
export const outboundProposalSchema = z.object({
  channel: outboundChannelSchema,
  /** The primary address: public profile email, else first commit email. */
  to: z.string().nullable(),
  /** Every known address for the person, primary first. */
  emails: z.array(z.string()),
  model: z.string(),
  /** Email only; null for messages without a subject line. */
  subject: z.string().nullable(),
  body: z.string(),
});
export type OutboundProposal = z.infer<typeof outboundProposalSchema>;
